import Vue from 'vue';
import VueStorage from 'vue-ls';

Vue.use(VueStorage, {
  namespace: 'cns_',
  name: '$ls',
  storage: 'local',
});
